import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";
import { VESSEL_TYPES } from "@/lib/constants";

export const TestsFilters = ({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  vesselFilter,
  setVesselFilter,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
}) => (
  <div className="bg-white border border-[#33424f]/20 p-4 mb-0 grid grid-cols-1 md:grid-cols-5 gap-3">
    <div className="md:col-span-2 relative">
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#50493b]" />
      <Input
        data-testid="test-search-input"
        placeholder="Search job number or notes…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="pl-9 border-[#33424f]/30 font-body"
      />
    </div>
    <Select value={statusFilter} onValueChange={setStatusFilter}>
      <SelectTrigger data-testid="status-filter" className="border-[#33424f]/30 font-body">
        <SelectValue placeholder="Status" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All statuses</SelectItem>
        <SelectItem value="Pending">Pending</SelectItem>
        <SelectItem value="Tested">Tested</SelectItem>
        <SelectItem value="Complete">Complete</SelectItem>
      </SelectContent>
    </Select>
    <Select value={vesselFilter} onValueChange={setVesselFilter}>
      <SelectTrigger data-testid="vessel-filter" className="border-[#33424f]/30 font-body">
        <SelectValue placeholder="Vessel type" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All vessels</SelectItem>
        {VESSEL_TYPES.map((v) => (
          <SelectItem key={v} value={v}>
            {v}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    <div className="grid grid-cols-2 gap-2">
      <Input
        data-testid="date-from"
        type="date"
        value={dateFrom}
        onChange={(e) => setDateFrom(e.target.value)}
        className="border-[#33424f]/30 font-body"
      />
      <Input
        data-testid="date-to"
        type="date"
        value={dateTo}
        onChange={(e) => setDateTo(e.target.value)}
        className="border-[#33424f]/30 font-body"
      />
    </div>
  </div>
);
